import "./App.css";
import { useCallback, useEffect, useState } from "react";
import { BrowserRouter, useLocation } from "react-router-dom";
import { RouterConfig } from "navigation/RouterConfig";
import { useNavigate } from "react-router-dom";
import { Provider } from "react-redux";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { store, persistor } from "redux/store";
import { PersistGate } from 'redux-persist/integration/react';
import moment from "moment";
import CommonDialog from "components/common/CommonDialog";
import { useDispatch } from "react-redux";
import { logout, updateUsersType } from "redux/actions/userActions";
import { PAGE, REFRESH_TOKEN, TERMINATE_TOKEN, TIME_REFRESH } from "components/common/CONSTANTS";
import { SOMS_API_KEY, AUTH } from "services/CONSTANTS";
import { postTokenSession, postToken } from "services/loginService";
import { decryption, encryptRequest } from "components/common/EncryptDecrypt";
import jwt_decode from "jwt-decode";
import { clearLocations } from "redux/actions/locationActions";
import { BroadcastChannel } from 'broadcast-channel';
import { resetUploadEmergencyError, resetUploadEmergencyOrder } from "redux/actions/emergencyOrderUploadAction";
import Footer from "components/Layout/footer";
import { clearReasonCodes } from "redux/actions/reasonCodesActions";
import { RESET_CREATE_PROCESS_ORDERS } from "redux/actions/action-type";
import { resetOrderOpportunities } from "redux/actions/createAction";
import { resetOrderCreateProcessOrders } from "redux/actions/createProcessOrderAction";
import { resetUploadManualOrder } from "redux/actions/manualUploadActions";
import { resetUploadPurchaseOrder } from "redux/actions/uploadManualPoAction";
const logoutChannel = new BroadcastChannel('logout');
const logoutChannelExtend = new BroadcastChannel('extend');
export const logoutAllTabs = () => {

  logoutChannel.onmessage = () => {
      logout();
    
      sessionStorage.clear();
      window.location.reload();
      logoutChannel.close();


  }
}
export const extendAllTabs = () => {

  logoutChannelExtend.onmessage = () => {
      
      window.location.reload();
      logoutChannel.close();


  }
}
const AppWrapper = () => {
  useEffect(() => {
   
      logoutAllTabs()
      extendAllTabs()
    
  
   }, [])
  return (
    <BrowserRouter>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <App />
        </PersistGate>
      </Provider>
    </BrowserRouter>
  );
};


function App() {

  const dispatch = useDispatch();
  let location = useLocation();
  const navigate = useNavigate();
  const [showAlertLogout, setShowAlert] = useState(false);
  const [isShowing, setIsShowing] = useState(false);
  const myInterval = "";
  const [counter, setCounter] = useState(120);
  const [running, setRunning] = useState(false);


  useEffect(() => {
    let interval;

    if (!running) {
      return () => { };
    }


    interval = setInterval(() => {
      setCounter((counter) => counter - 1);
      return () => { setIsShowing(false) }
    }, 1000);

    return () => {

      clearInterval(interval);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [running]);
 

  let timeChecker = () => {
    let token = sessionStorage.getItem("token");
    if (token !== null) {
      let tokenData = JSON.parse(atob(token.split(".")[1]));
      let expiry = tokenData.exp;
      let d = new Date(expiry * 1000); // The 0 there is the key, which sets the date to the epoch
      let expiry1 = d.toISOString();

      let today = localStorage.getItem("lastTimeStamp");
      let loggedInTimestamp = sessionStorage.getItem("loggedInTimestamp");
      let LoggedTime = new Date(loggedInTimestamp);
      let LoggedInTime = new Date(LoggedTime.toISOString());

      let startTime = new Date(today);
      let Starttime = new Date(startTime.toISOString());
      let endTime = new Date(expiry1);

      let CurrtimeStamp = new Date();
      let currDate = new Date(CurrtimeStamp.toISOString());
      let activeTime = Math.abs(currDate.getTime() - LoggedInTime.getTime());
      let idleTime = Math.abs(currDate.getTime() - Starttime.getTime()); // This will give difference in milliseconds
      let resultInMinutes = Math.round(idleTime / 60000);
      let activeTimeinMinutes = Math.round(activeTime / 60000);




      if (endTime.getTime() < currDate.getTime()) {


        sessionStorage.clear();

        if (myInterval !== undefined && myInterval !== "undefined") {
          window.clearInterval(myInterval);
          
        }
        window.location.reload();
      } else {
        if (activeTimeinMinutes >= TIME_REFRESH) {

          if (resultInMinutes >= TIME_REFRESH) {

            setShowAlert(true);
            setIsShowing(true);
            setRunning(true);
            setCounter(120);

          }
        }
        if (activeTimeinMinutes >= TIME_REFRESH) {
         
          let timeStamp = moment();
          sessionStorage.setItem("loggedInTimestamp", timeStamp);

          silentLogin();
        }
      }
    }
  
  };


  const silentLogin = () => {
    let token = sessionStorage.getItem("token");
   let refresh_token = sessionStorage.getItem("refreshToken");
  
    let encoded = window.btoa(AUTH);

    const params = new URLSearchParams();
    params.append("grant_type", "refresh_token");
    params.append("refresh_token", refresh_token);

    const request2 = {
      config: {
        headers: {
          Authorization: "Basic " + window.atob(encoded),
          "Content-Type": "application/x-www-form-urlencoded",
          "Content-Security-Policy": "strict-dynamic",
          "X-Content-Type-Options": "nosniff"
        }
      },
      params
    }

    postToken(request2).then(async(response) => {
    
      const credentials = jwt_decode(token);
      const finalReq = {
        "tokenType": REFRESH_TOKEN,
        "accessToken": response.access_token,
        "expiresIn": response.expires_in,
        "refreshToken": response.refresh_token,
        "scope": "",
        "userType": "",
        "empId": "",
        "primaryEmailAddress": credentials.email,
        "roleCode": "",
        "roles": "",
      }
      const request1 = await encryptRequest(finalReq)
      const request = {
        apikey: SOMS_API_KEY,
        params: {
          token: request1
        },
        userId: credentials.email
      }

      postTokenSession(request).then(async(res) => {

        const data = res.responseData
        let response = JSON.parse( await decryption(data));
        let accessToken = response.accessToken;
        let refreshToken = response.refreshToken;

        localStorage.setItem("expires_in", response.expires_in);
        sessionStorage.clear();
        sessionStorage.setItem("token", token);
        sessionStorage.setItem(
          "lastTimeStamp",
          localStorage.getItem("lastTimeStamp")
        );
        sessionStorage.setItem("refreshToken", refreshToken);
        sessionStorage.setItem("accessToken", accessToken);
        let timeStamp = moment();
        sessionStorage.setItem("loggedInTimestamp", timeStamp);

        dispatch(updateUsersType(response))
      }).catch(error => {
        console.log(error)
      })
    }).catch(error => {
        console.log(error)

    })

  };

  let resetTimer = useCallback(() => {

    let token = sessionStorage.getItem("token");
    
    if (token !== "") {
      let timeStamp = moment();
      localStorage.setItem("lastTimeStamp", timeStamp);
      timeChecker();
    }

    let timeInterval = 1000 * 60 * 1;
    window.myInterval = setInterval(function () { timeChecker(); }, timeInterval)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleLogout = async() => {
    dispatch(clearLocations())
    dispatch(clearReasonCodes());
    const token = sessionStorage.getItem("token")
    
    if (token !== "" && token !== null) {
      const credentials = jwt_decode(token);
      const finalReq = {
        "tokenType": TERMINATE_TOKEN,
        "accessToken": "",
        "expiresIn": "",
        "refreshToken": sessionStorage.getItem("refreshToken"),
        "scope": "",
        "userType": "",
        "empId": "",
        "primaryEmailAddress": credentials.email,
        "roleCode": "",
        "roles": "",
      }
      const request1 = await encryptRequest(finalReq)

      const request = {
        apikey: SOMS_API_KEY,
        params: {
          token: request1
        },
        userId: credentials.email
      }
      postTokenSession(request).then(res => {
        logoutChannel.postMessage("Logout")
        dispatch(logout());
        window.onbeforeunload = function() {
          localStorage.clear();
       }
        sessionStorage.clear();
        setIsShowing(false)
        navigate("/");
        window.location.reload();

        if (myInterval !== undefined && myInterval !== 'undefined') {
          window.clearInterval(myInterval);
          
        }


      }).catch(error => {
        console.log(error)
      })
    }

  };
  const handleExtend = () => {
    logoutChannelExtend.postMessage("extend")
    setRunning(false);
    setCounter(0);
    setIsShowing(false)
    silentLogin()


  };

  const handleCancel = () => {
    logoutChannelExtend.postMessage("extend")
    setRunning(false);
    setCounter(0);
    setShowAlert(false)
    silentLogin();
  }
 
 
  // Life cycle hook
  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const events = ["click", "keypress", "load"]
    events.forEach((event) => {
      window.addEventListener(event, resetTimer);

    });
   

  }, [resetTimer]);

  useEffect(() => {
    return () => {
      if(location.pathname!==PAGE.VALIDATE_EMERGENCY_ORDERS.url && location.pathname !==PAGE.UPLOAD_EMERGENCY_ORDERS.url){

        dispatch(resetUploadEmergencyOrder()); //back button implementation
        dispatch(resetUploadEmergencyError());
      }
      if(location?.pathname!==PAGE?.ERROR_FEEDBACK?.url || location?.pathname===PAGE?.CREATE_MANUAL_ORDERS?.url ||location?.pathname ===PAGE?.AMEND_MANUAL_ORDERS?.url || location?.pathname ===PAGE?.APPROVE_MANUAL_ORDERS?.url 
        ||location?.pathname ===PAGE?.GOLDEN_STORE?.url || location?.pathname ===PAGE?.VIEW_MANUAL_ORDERS?.url 
      ||location?.pathname ===PAGE?.VIEW_MANUAL_ORDERS_AUDIT_DETAILS?.url ||location?.pathname ===PAGE?.MANAGE_USER?.url ||location?.pathname ===PAGE?.SITE_CANTEEN?.url){
        dispatch({ type: RESET_CREATE_PROCESS_ORDERS });
         dispatch(resetOrderCreateProcessOrders());
        dispatch(resetUploadManualOrder());
      }
      if(location?.pathname!==PAGE?.CREATE_MANUAL_ORDERS?.url || location?.pathname===PAGE?.ERROR_FEEDBACK?.url ||location?.pathname ===PAGE?.AMEND_MANUAL_ORDERS?.url || location?.pathname ===PAGE?.APPROVE_MANUAL_ORDERS?.url 
        ||location?.pathname ===PAGE?.GOLDEN_STORE?.url || location?.pathname ===PAGE?.VIEW_MANUAL_ORDERS?.url 
      ||location?.pathname ===PAGE?.VIEW_MANUAL_ORDERS_AUDIT_DETAILS?.url || location?.pathname ===PAGE?.MANAGE_USER?.url ||location?.pathname ===PAGE?.SITE_CANTEEN?.url){
        dispatch(resetOrderOpportunities());
        
      }
      if(location?.pathname !==PAGE?.UPLOAD_CREATE_MANUAL_ORDER_PO?.url || location?.pathname ===PAGE?.CREATE_MANUAL_ORDER_PO?.url || location?.pathname ===PAGE?.PO_SUMMARY?.url || location?.pathname ===PAGE?.ERROR_FEEDBACK?.url || location?.pathname===PAGE?.CREATE_MANUAL_ORDERS?.url ||location?.pathname ===PAGE?.AMEND_MANUAL_ORDERS?.url || location?.pathname ===PAGE?.APPROVE_MANUAL_ORDERS?.url 
        ||location?.pathname ===PAGE?.GOLDEN_STORE?.url || location?.pathname ===PAGE?.VIEW_MANUAL_ORDERS?.url 
      ||location?.pathname ===PAGE?.VIEW_MANUAL_ORDERS_AUDIT_DETAILS?.url ||location?.pathname ===PAGE?.MANAGE_USER?.url ||location?.pathname ===PAGE?.SITE_CANTEEN?.url){
        dispatch({ type: RESET_CREATE_PROCESS_ORDERS });
         dispatch(resetOrderCreateProcessOrders());
        dispatch(resetUploadManualOrder());
        dispatch(resetUploadPurchaseOrder());
      }
      
    };
  }, [location,dispatch]);

  return (
    <div className="App" style={{display:'flex',flexDirection:'column',height:'100%', justifyContent:'space-between'}}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <RouterConfig />
        {showAlertLogout ? (
          <CommonDialog
            isShowing={isShowing}
            title="User InActive"
            content="Your session will expire soon. Do you want to continue? Yes or No"
            button1='NO'
            button2='YES'
            onClick={handleLogout}
            onClose={handleExtend}
            onCancel={handleCancel}
            timer={counter}
          />

        ) : (
          ""
        )}
      </LocalizationProvider>
      <Footer />
    </div>
  );
}

export default AppWrapper;
